import { isExternal } from "./is-external";

type CleanHrefOptions = {
  href: string;
  siteBasePath: string;
};

export const cleanHrefWithSiteBasePath = ({
  href,
  siteBasePath,
}: CleanHrefOptions): string => {
  if (isExternal(href, siteBasePath)) {
    return href;
  }

  const url = new URL(href, "http://dummy-base");

  const pathnameWithoutTrailingSlash = url.pathname.replace(/\/+$/, "");
  let pathname = pathnameWithoutTrailingSlash || "/";

  if (!pathname.startsWith(siteBasePath)) {
    pathname = siteBasePath + pathname;
  }

  if (pathname.endsWith("/")) {
    pathname = pathname.slice(0, -1);
  }

  return `${pathname}${url.search}${url.hash}`;
};
